<div class="login-wrapper">
    <mat-card appearance="outlined" class="login-card">
        <mat-card-title><h2>Login</h2></mat-card-title>
        <mat-card-subtitle
        ><p>
            On your first login you will be registered with OIDC provider.
            <br>
            If you are already registered select your provider.
        </p>
        </mat-card-subtitle>
        <mat-card-content>
            <sentinel-auth-provider-list class="providers" />
        </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="consent-card">
        <mat-card-title>Access consent</mat-card-title>
        <mat-card-subtitle>
            <p>
                When accessing the CyberRangeᶜᶻ Platform, your personal data, such as your name and e-mail, as well as
                any
                data generated by your interaction with the CyberRangeᶜᶻ Platform, will be processed for the purposes of
                providing the service and only for this period to ensure proper operation of the service. After the
                termination of the service, your personal data will be anonymized and further used only for scientific
                and
                research purposes.
                This will apply as well to other data created by your interaction with the CyberRangeᶜᶻ Platform.
                For more information, please contact us at <a id="consent-address" href="mailto:info@cyberrange.cz">
                info&#64;cyberrange.cz</a>.
            </p>
        </mat-card-subtitle>
    </mat-card>
</div>
